import { render } from "./HomePatent.vue?vue&type=template&id=a34399e6&scoped=true"
import script from "./HomePatent.vue?vue&type=script&lang=js"
export * from "./HomePatent.vue?vue&type=script&lang=js"

import "./HomePatent.vue?vue&type=style&index=0&id=a34399e6&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34399e6"]])

export default __exports__